import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from './tooltip';
import Icon from 'components/icon';
import Popover from 'components/popover';
import { writeToClipboard } from 'utils/clipboard';

import './tooltip.scss';

export default class ClickToCopy extends React.PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    message: PropTypes.string,
    icon: PropTypes.string,
    fa: PropTypes.string,
    faType: PropTypes.string,
    children: PropTypes.node,
  };

  onClick = () => {
    const { value } = this.props;

    writeToClipboard(value);
  };

  render() {
    const { message = 'Copied', icon, fa, faType, children } = this.props;

    return (
      <span className="tooltip-click-to-copy">
        <Popover
          align="middle"
          message={message}
          triggerChildren={
            <>
              {icon ? (
                <Icon type={icon} />
              ) : fa ? (
                <Icon fa={fa} faType={faType} />
              ) : (
                children || <Icon fa="copy" />
              )}
            </>
          }
          onClick={this.onClick}
          openOnHover={false}
          openOnClick={true}
        />
      </span>
    );
  }
}
